let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fRQeP")).then(() => parcelRequire('9j532'));